import { CheckoutComponentChatAttibutesType } from "../../types/builder";
import { formatPhoneNumber } from "../../utils/format";
import CustomChatCard from "./CustomChatCard";

const Whatsapp: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <CustomChatCard
      icon="/assets/whatsapp.png"
      title="Whatsapp"
      href={`https://wa.me/${formatPhoneNumber(accountId)}`}
    />
  );
};

export default Whatsapp;
